import _extends from "@babel/runtime/helpers/extends";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import { refreshButtonTheme } from './refreshButtonStyles';
export var RefreshButton = function RefreshButton(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: refreshButtonTheme
  }, /*#__PURE__*/React.createElement(Button, _extends({
    disableRipple: true,
    className: "EmbersRefreshButton-root"
  }, props), /*#__PURE__*/React.createElement("i", {
    role: "none",
    className: "icon-reload"
  })));
};